import React from "react";
import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import { NavLink } from "react-router";

import logo from './logo.svg';
import './App.css';

function App() {

  /*ReactDOM.render(
    <Countdown date={Date.now() + 10000} />,
    document.getElementById('root')
  
  #6d0020
  #470015
  #910ca8
  );*/

  return (
    <div className="App bg-a2c-green text-white font-bold">
      <nav className="grid grid-cols-2 gap-48 pt-4 pb-4">
        <NavLink to="/" className="labelText text-3xl text-left ml-48 mt-1 hover:text-gray-200" end>AETEAU</NavLink>
        <div className="grid grid-cols-3 mt-2 text-lg mr-24">
          <NavLink to="/academics" className="hover:text-gray-200" end>Academics</NavLink>
          <NavLink to="/student-life" className="hover:text-gray-200">Student Life</NavLink>
          <NavLink to="/application" className="hover:text-gray-200">Apply</NavLink>
        </div>
      </nav>
    </div>
  );
}

export default App;
